import FullPageLayout from "../../../../templates/FullPageLayout";
import { Button, Col, Row } from "antd";
import { NeedHelp } from "../../../../atoms/CustomIcons";
import ClientIndividual from "./Tabs/ClientIndividual";
import ClientCompany from "./Tabs/ClientCompany";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../config/hooks";
import {
  removeSubDetailData,
  getSubcontractorDetails,
} from "../../ducks/actions";

export default function EditSubcontractor() {
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();
  const location = window.location.pathname;
  const pathSegments = location.split("/");
  const companyId = pathSegments[pathSegments.length - 1];
  const clientId = pathSegments[pathSegments.length - 2];

  const SubDetailData = useAppSelector(
    (state) => state?.crewsSubs?.SubDetailData
  );

  useEffect(() => {
    dispatch(removeSubDetailData());
  }, [dispatch]);

  useEffect(() => {
    if (clientId) {
      dispatch(getSubcontractorDetails(clientId));
    }
  }, [dispatch, clientId]);

  return (
    <FullPageLayout loading={loading || SubDetailData?.loader}>
      <Button className="btn-sm fixedTopBtn">
        <NeedHelp /> Need help?
      </Button>

      <div>
        <Row gutter={8} style={{ width: "672px" }}>
          <Col span={24}>
            <div
              className="title"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
              }}
            >
              <div>
                <h2>
                  Edit subcontractor{" "}
                  {SubDetailData?.data?.type && (
                    <span
                      style={{ textTransform: "capitalize", fontSize: "20px" }}
                    >
                      ({SubDetailData?.data?.type})
                    </span>
                  )}
                </h2>
                <p>Subs complete their services during scheduled visits.</p>
              </div>
            </div>
          </Col>

          <Col span={24}>
            <div>
              <Row gutter={20}>
                <Col span={24}>
                  <div
                    style={{
                      position: "absolute",
                      zIndex: 99,
                      width: "calc(100% - 20px)",
                      left: "11px",
                      top: "0",
                      paddingLeft: "20px",
                      paddingTop: "20px",
                    }}
                  >
                    <h4 style={{ marginBottom: "16px" }}> General details </h4>
                  </div>

                  {SubDetailData?.data?.type === "company" && (
                    <ClientCompany
                      setLoading={setLoading}
                      companyId={companyId}
                      clientId={clientId}
                      clientDetailData={SubDetailData?.data}
                    />
                  )}

                  {SubDetailData?.data?.type === "individual" && (
                    <ClientIndividual
                      setLoading={setLoading}
                      companyId={companyId}
                      clientId={clientId}
                      clientDetailData={SubDetailData?.data}
                    />
                  )}
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </div>
    </FullPageLayout>
  );
}
